import React, { useEffect } from 'react'
import NewHomePage from "../home/NewThemeHomePage";
import MobileHomePage from '../home/MobileHomePage';

const HomepageContainer = () => {
  if(window.document.body.clientWidth < 800 || window.cordova) {
    return <MobileHomePage/>
  }
  return <NewHomePage/>
}

export default HomepageContainer;